import { useEffect, useRef } from 'react'
import type L from 'leaflet'

interface UseMapInteractionsProps {
  mapRef: React.MutableRefObject<L.Map | null>
  isInitializedRef: React.MutableRefObject<boolean>
  saveMapSnapshot: () => void
}

export const useMapInteractions = ({
  mapRef,
  isInitializedRef,
  saveMapSnapshot,
}: UseMapInteractionsProps) => {
  const userHasInteractedRef = useRef(false)
  const isUserDraggingRef = useRef(false)

  useEffect(() => {
    if (!mapRef.current || !isInitializedRef.current) return

    const map = mapRef.current

    const handleDragStart = () => {
      isUserDraggingRef.current = true
      userHasInteractedRef.current = true
    }

    const handleDragEnd = () => {
      isUserDraggingRef.current = false
      saveMapSnapshot()
    }

    const handleZoomStart = () => {
      userHasInteractedRef.current = true
    }

    const handleZoomEnd = () => {
      saveMapSnapshot()
    }

    const handleLoad = () => {
      saveMapSnapshot()
    }

    map.on('dragstart', handleDragStart)
    map.on('dragend', handleDragEnd)
    map.on('zoomstart', handleZoomStart)
    map.on('zoomend', handleZoomEnd)
    map.on('load', handleLoad)

    return () => {
      map.off('dragstart', handleDragStart)
      map.off('dragend', handleDragEnd)
      map.off('zoomstart', handleZoomStart)
      map.off('zoomend', handleZoomEnd)
      map.off('load', handleLoad)
    }
  }, [mapRef, isInitializedRef, saveMapSnapshot])

  return { userHasInteractedRef, isUserDraggingRef }
}
